export default __webpack_public_path__ + "static/noise-371d72175aafed861a68c9b3beb98584.webp";